<template>
  <div>
    <div class="dashboard-section-title mt-5 mb-5">Información y beneficios</div>
    <v-row class="dashboard-row">
      <v-col v-for="benefit in beneficios" :key="benefit.titulo" cols="12" md="4">
        <a
          v-if="isExternalBenefit(benefit)"
          v-bind="getExternalBenefitProps(benefit)"
          class="dashboard-card benefit-card rounded-xl pa-4"
        >
          <v-avatar :color="benefit.bg" size="54" class="mr-4">
            <v-icon :color="benefit.color" size="34">{{ benefit.icon }}</v-icon>
          </v-avatar>
          <div>
            <div class="dashboard-card-title">{{ benefit.titulo }}</div>
            <p class="caption grey--text text--darken-1 mb-1">{{ benefit.descripcion }}</p>
            <span class="benefit-link">{{ benefit.link }} 
              
              <v-icon x-small color="primary">mdi-arrow-right</v-icon>
            </span>
          </div>
        </a>
        <v-card
          v-else
          elevation="3"
          class="dashboard-card benefit-card rounded-xl pa-4"
          :to="getInternalBenefitTo(benefit)"
        >
          <v-avatar :color="benefit.bg" size="54" class="mr-4">
            <v-icon :color="benefit.color" size="34">{{ benefit.icon }}</v-icon>
          </v-avatar>
          <div>
            <div class="dashboard-card-title">{{ benefit.titulo }}</div>
            <p class="caption grey--text text--darken-1 mb-1">{{ benefit.descripcion }}</p>
            <span class="benefit-link">{{ benefit.link }} 
              
              <v-icon x-small color="primary">mdi-arrow-right</v-icon>
            </span>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "BenefitsGrid",
  props: {
    beneficios: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    isExternalBenefit(benefit) {
      const type = `${benefit.tipo || benefit.type || ""}`.toLowerCase();
      const target = benefit.url || benefit.href || benefit.linkUrl || benefit.to;

      if (["link", "url", "externo", "external"].includes(type)) return true;
      if (["ruta", "route", "interno", "internal"].includes(type)) return false;

      return typeof target === "string" && /^(https?:|mailto:|tel:)/i.test(target);
    },
    getExternalBenefitProps(benefit) {
      return {
        href: benefit.url || benefit.href || benefit.linkUrl || benefit.to,
        target: benefit.target || "_blank",
        rel: "noopener noreferrer"
      };
    },
    getInternalBenefitTo(benefit) {
      if (benefit.routeName) {
        return {
          name: benefit.routeName,
          params: benefit.params || {},
          query: benefit.query || {}
        };
      }

      return benefit.to || benefit.route || "/inicio";
    }
  }
};
</script>

<style scoped>
.dashboard-row > .col,
.dashboard-row > [class*="col-"] {
  padding-bottom: 8px;
  padding-top: 8px;
}

.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
  color: inherit;
  text-decoration: none;
}

.dashboard-card-title,
.dashboard-section-title {
  color: #20333a;
  font-weight: 700;
}

.dashboard-card-title {
  font-size: 0.94rem;
  line-height: 1.2;
}

.dashboard-section-title {
  font-size: 1.05rem;
}

.benefit-card {
  align-items: center;
  display: flex;
  min-height: 90px;
  text-decoration: none;
}

.benefit-link {
  color: var(--v-primary-base);
  font-size: 0.9rem;
  font-weight: 700;
}

@media (max-width: 599px) {
  .benefit-card {
    align-items: flex-start;
  }
}
</style>
